/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends HTMLElement {
  static SEMANTIC_TAGS = new Set([
    'P', 'A', 'STRONG', 'B', 'EM', 'I', 'U', 'S',
    'H1', 'H2', 'H3', 'H4', 'H5', 'H6',
    'UL', 'OL', 'LI', 'BR', 'HR',
    'BLOCKQUOTE', 'TABLE', 'THEAD', 'TBODY', 'TR', 'TH', 'TD',
    'IMG', 'FIGURE', 'FIGCAPTION', 'VIDEO', 'SOURCE',
  ]);

  connectedCallback() {
    this.#sanitize();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  #sanitize() {
    this.querySelectorAll('*').forEach((el) => {
      el.removeAttribute('class');
      el.removeAttribute('style');
      el.removeAttribute('lang');

      for (const attr of [...el.attributes]) {
        if (attr.name.startsWith('data-')) el.removeAttribute(attr.name);
      }

      if (el.tagName === 'DIV' && !RTEFormatter.SEMANTIC_TAGS.has('DIV')) {
        el.replaceWith(...el.childNodes);
      }
    });
  }

  /**
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
